// Messages for operator/Quotes (auto-merged into the i18n catalog by lib/i18n.ts).
export const en = {
  'operator.quotes.head': 'Quotes — Operator',
  'operator.quotes.title': 'Quotes',
  'operator.quotes.subtitle.templates':
    'Reusable, shared quote templates — applied when building a quote',
  'operator.quotes.subtitle.quotes': '{count} shown · build, price & convert — with cost & margin',
  'operator.quotes.new_template': 'New template',
  'operator.quotes.new_quote': 'New quote',
  'operator.quotes.tab.quotes': 'Quotes',
  'operator.quotes.tab.templates': 'Templates',
  'operator.quotes.search.aria': 'Search quotes',
  'operator.quotes.search.placeholder': 'Search ref, customer, lane…',
  'operator.quotes.filter.status.aria': 'Filter by status',
  'operator.quotes.filter.status.all': 'All statuses',
  'operator.quotes.filter.customer.aria': 'Filter by customer',
  'operator.quotes.filter.customer.all': 'All customers',
  'operator.quotes.mode.all': 'All',
  'operator.quotes.mode.ship': 'Ocean',
  'operator.quotes.mode.air': 'Air',
  'operator.quotes.mode.truck': 'Truck',
  'operator.quotes.mode.train': 'Rail',
  'operator.quotes.clear': 'Clear',
  'operator.quotes.col.ref': 'Ref',
  'operator.quotes.col.customer_lane': 'Customer / Lane',
  'operator.quotes.col.cost': 'Cost',
  'operator.quotes.col.sell': 'Sell',
  'operator.quotes.col.margin': 'Margin',
  'operator.quotes.col.status': 'Status',
  'operator.quotes.col.created': 'Created',
  'operator.quotes.empty': 'No quotes match these filters.',
  'operator.quotes.apply_template': 'Apply a template',
  'operator.quotes.load_more': 'Load more',
  'operator.quotes.tpl.col.template': 'Template',
  'operator.quotes.tpl.col.mode': 'Mode',
  'operator.quotes.tpl.col.contents': 'Contents',
  'operator.quotes.tpl.empty': 'No templates yet — create one, or save a quote as a template.',
  'operator.quotes.tpl.mode.any': 'Any',
  'operator.quotes.tpl.line_item': '{count} line item',
  'operator.quotes.tpl.line_items': '{count} line items',
  'operator.quotes.tpl.use': 'Build a quote from this template',
  'operator.quotes.tpl.note':
    'Templates are created & edited here by your team and applied when building a quote — replacing the old hardcoded list.',
}

export const zhTW = {
  'operator.quotes.head': '報價 — 操作端',
  'operator.quotes.title': '報價',
  'operator.quotes.subtitle.templates': '可重複使用的共享報價範本 — 建立報價時套用',
  'operator.quotes.subtitle.quotes': '顯示 {count} 件 · 建立、定價與轉換 — 含成本與毛利',
  'operator.quotes.new_template': '新增範本',
  'operator.quotes.new_quote': '新增報價',
  'operator.quotes.tab.quotes': '報價',
  'operator.quotes.tab.templates': '範本',
  'operator.quotes.search.aria': '搜尋報價',
  'operator.quotes.search.placeholder': '搜尋參考號、客戶、航線…',
  'operator.quotes.filter.status.aria': '依狀態篩選',
  'operator.quotes.filter.status.all': '所有狀態',
  'operator.quotes.filter.customer.aria': '依客戶篩選',
  'operator.quotes.filter.customer.all': '所有客戶',
  'operator.quotes.mode.all': '全部',
  'operator.quotes.mode.ship': '海運',
  'operator.quotes.mode.air': '空運',
  'operator.quotes.mode.truck': '卡車',
  'operator.quotes.mode.train': '鐵路',
  'operator.quotes.clear': '清除',
  'operator.quotes.col.ref': '參考號',
  'operator.quotes.col.customer_lane': '客戶 / 航線',
  'operator.quotes.col.cost': '成本',
  'operator.quotes.col.sell': '售價',
  'operator.quotes.col.margin': '毛利',
  'operator.quotes.col.status': '狀態',
  'operator.quotes.col.created': '建立時間',
  'operator.quotes.empty': '沒有符合這些篩選條件的報價。',
  'operator.quotes.apply_template': '套用範本',
  'operator.quotes.load_more': '載入更多',
  'operator.quotes.tpl.col.template': '範本',
  'operator.quotes.tpl.col.mode': '運輸方式',
  'operator.quotes.tpl.col.contents': '內容',
  'operator.quotes.tpl.empty': '尚無範本 — 建立一個，或將報價儲存為範本。',
  'operator.quotes.tpl.mode.any': '不限',
  'operator.quotes.tpl.line_item': '{count} 個項目',
  'operator.quotes.tpl.line_items': '{count} 個項目',
  'operator.quotes.tpl.use': '以此範本建立報價',
  'operator.quotes.tpl.note':
    '範本由您的團隊在此建立與編輯，並在建立報價時套用 — 取代舊有的硬編碼清單。',
}
